// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"78366002","199":"26e3273f","432":"26e3273f","553":"26e3273f","945":"26e3273f"}[chunkId] + ".chunk.css";
};